export default __webpack_public_path__ + "static/media/geometryBrawl.99d70c77.png";